import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HomeQuickActionPrompt } from '../home.models';

@Component({
  selector: 'app-home-hero-section',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home-hero-section.component.html',
})
export class HomeHeroSectionComponent {
  @Input() userName = '';
  @Input() chatMessage = '';
  @Input() currentPrompt: HomeQuickActionPrompt | null = null;
  @Input() nextPrompt: HomeQuickActionPrompt | null = null;
  @Input() hasQuickPrompts = false;
  @Input() isPromptTransitioning = false;

  @Output() chatMessageChange = new EventEmitter<string>();
  @Output() sendRequested = new EventEmitter<void>();
  @Output() quickPromptSelected = new EventEmitter<HomeQuickActionPrompt>();

  onChatMessageChange(value: string): void {
    this.chatMessageChange.emit(value);
  }

  onSend(): void {
    if (!this.chatMessage?.trim()) {
      return;
    }

    this.sendRequested.emit();
  }

  onPromptSelected(prompt: HomeQuickActionPrompt | null): void {
    if (!prompt) {
      return;
    }

    this.quickPromptSelected.emit(prompt);
  }
}
